import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

export const RAPI = `${process.env.REACT_APP_BACKEND_URL}/api/rollout`;

export const STAGES = [
  ["invited", "Invited"], ["signed_up", "Signed up"], ["approved", "Approved"], ["gingr_connected", "Gingr connected"],
  ["first_sync", "First sync done"], ["trained", "Trained"], ["live", "Live"],
];
export const stageLabel = (s) => (STAGES.find(([k]) => k === s) || [s, "Added"])[1];

export const useApi = (path) => {
  const [data, setData] = useState(null);
  const load = useCallback(() => axios.get(`${RAPI}${path}`).then((r) => setData(r.data)).catch((e) => toast.error(e.response?.data?.detail || "Couldn't load")), [path]);
  useEffect(() => { load(); }, [load]);
  return [data, load];
};

export const act = async (fn, ok, after) => {
  try { const r = await fn(); if (ok) toast.success(typeof ok === "function" ? ok(r.data) : ok); if (after) after(); return r.data; }
  catch (e) { toast.error(e.response?.data?.detail || "Something went wrong"); return null; }
};

export const when = (iso) => (iso ? new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—");
export const day = (iso) => (iso ? new Date(iso.length === 10 ? `${iso}T12:00:00` : iso).toLocaleDateString([], { month: "short", day: "numeric" }) : "—");

const RAG = { green: ["var(--pos)", "Green"], amber: ["var(--warn)", "Amber"], red: ["var(--neg)", "Red"] };
export const Rag = ({ c, testid }) => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12, fontWeight: 600 }} data-testid={testid}>
    <span style={{ width: 10, height: 10, borderRadius: 5, background: RAG[c][0] }} />{RAG[c][1]}
  </span>
);

export const StageTrack = ({ stage, testid }) => {
  const idx = STAGES.findIndex(([k]) => k === stage);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }} data-testid={testid}>
      <div style={{ display: "flex", gap: 3 }}>
        {STAGES.map(([k, l], i) => <span key={k} title={l} style={{ width: 14, height: 6, borderRadius: 3, background: i <= idx ? (stage === "live" ? "var(--pos)" : "var(--accent)") : "var(--track)" }} />)}
      </div>
      <span style={{ fontSize: 12, fontWeight: 600, whiteSpace: "nowrap" }}>{stageLabel(stage)}</span>
    </div>
  );
};

export const Th = ({ cols }) => <thead><tr>{cols.map((h) => <th key={h} style={{ textAlign: "left", whiteSpace: "nowrap" }}>{h}</th>)}</tr></thead>;
